import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import VentistillingsdetailUtskrift from "./VentilstillingsdetailUtskrift";

import { getVentilstilling as getVentilstillingAction } from "../../../actions/ventilstillingerActions";

function VentilstillingsdetailUtskriftPage() {
  const dispatch = useDispatch();
  const ventilstilling = useSelector((state) => state.ventilstilling);

  const getVentilstilling = useCallback(
    (id) => dispatch(getVentilstillingAction(id)),
    [dispatch],
  );

  return (
    <VentistillingsdetailUtskrift
      ventilstilling={ventilstilling}
      getVentilstilling={getVentilstilling}
    />
  );
}

export default VentilstillingsdetailUtskriftPage;
